module.exports = __webpack_public_path__ + "img/imagem-04-detalhada-palmeiras-01.40e5eaa4.png";